import React, { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import DoneIcon from "@mui/icons-material/Done";
import moment from "jalali-moment";

// import JS files
import MuiDatePicker from "../../shares/MuiDatePicker";
import RemoveModalTemplate from "../../shares/RemoveModalTemplate";
import OrderCard from "../../shares/OrderCard";
import COrderCard from "../../shares/COrderCard";

const CustomerOrderCard = ({
  children,
  canRemove,
  item,
  showAcceptBtn,
  update_ring_item,
  delete_ring_item,
  move_date_to_parent,
  apiCall = null,
  disabled = false,
  didNotNeedDiff,
  dontShowDatePicker,
}) => {
  const [openRemoveModal, setOpenRemoveModal] = useState(false);
  const handleRemoveModal = () => {
    setOpenRemoveModal((before) => !before);
  };

  const [dateValue, setDateValue] = useState(
    moment(item.receive_at).format("YYYY-MM-DD")
  );

  function dateOnChange(date) {
    setDateValue(date);
    if (!disabled) {
      move_date_to_parent(date);
    }
  }

  return (
    <>
      {openRemoveModal && (
        <RemoveModalTemplate
          openModal={openRemoveModal}
          setOpenModal={setOpenRemoveModal}
          accept={() => {
            delete_ring_item(item.id);
            setOpenRemoveModal(false);
          }}
          text="آیا از حذف محصول موردنظر از لیست سفارش خود اطمینان دارید؟"
        />
      )}
      <div
        className="border rounded-lg p-2 mt-2"
        style={{ backgroundColor: "#fefcfb" }}
      >
        <COrderCard
          ring={item.bangle}
          item={item}
          adminNeedDifference={didNotNeedDiff !== undefined ? false : true}
        >
          <div className="md:grid grid-cols-12 gap-x-2 items-center">
            <div className="md:col-span-8">{children}</div>
            <div className="col-span-4 grid grid-cols-4">
              {dontShowDatePicker ? null : (
                <div className="col-span-2 mt-2 md:-mt-1">
                  <MuiDatePicker
                    disabled={disabled}
                    onChange={dateOnChange}
                    value={dateValue}
                  />
                </div>
              )}

              {canRemove && (
                <div
                  className="delete-icon col-span-1 text-left md:text-center mt-4 md:mt-1"
                  onClick={() => handleRemoveModal()}
                >
                  <DeleteIcon />
                </div>
              )}
              {showAcceptBtn && (
                <div
                  className="accept-icon col-span-1 text-left md:text-center mt-4 md:mt-1"
                  onClick={() => update_ring_item(item.id)}
                  disabled={apiCall !== null ? apiCall.loading : false}
                >
                  <DoneIcon />
                </div>
              )}
            </div>
          </div>
        </COrderCard>
      </div>
    </>
  );
};

export default CustomerOrderCard;
